import {
	addCoFComponent,
	getCoFComponentsRejected,
	getCoFComponentsResolved,
	setCoFComponents,
	saveCoFResolved,
	setCoFComponent,
	addCoFConfig,
	setCoFConfig,
	deleteCoFCategory,
	getCoFFieldsResolved,
	getCoFFieldsRejected,
	getCoFFields,
	setCoFIsChanged,
} from '@Actions';
import { createReducer } from '@reduxjs/toolkit';
import { Category, CoFStoreState, ComponentField } from '@Types';
import { sortFields } from '@Utils/sort';
import { AnyAction } from 'redux';

export const initState: CoFStoreState = {
	componentFields: [],
	categories: [],
	isLoadingCategories: false,
	isLoadingFields: false,
	componentFieldsLoaded: false,
	isChanged: false,
	isValid: true,
};

interface CoFReducer {
	[x: string]: (
		state: CoFStoreState,
		action: AnyAction,
	) => CoFStoreState | undefined;
}

export const reducer: CoFReducer = {
	[getCoFComponentsResolved.toString()]: (state, action) => {
		const category: Category[] = action.payload;
		return {
			...state,
			categories: category,
			isLoadingCategories: false,
		};
	},
	[getCoFComponentsRejected.toString()]: state => ({
		...state,
		isLoadingFields: false,
	}),
	[getCoFFields.toString()]: state => ({
		...state,
		componentFields: [],
		isLoadingFields: true,
		componentFieldsLoaded: false,
	}),
	[getCoFFieldsResolved.toString()]: (state, action) => {
		const fields: ComponentField[] = action.payload;
		return {
			...state,
			componentFields: sortFields(fields),
			isLoadingFields: false,
			componentFieldsLoaded: true,
		};
	},
	[getCoFFieldsRejected.toString()]: state => ({
		...state,
		isLoadingFields: false,
	}),
	[addCoFConfig.toString()]: (state, action) => ({
		...state,
		categories: [...(state.categories || []), action.payload],
		isChanged: true,
	}),
	[setCoFConfig.toString()]: (state, action) => ({
		...state,
		categories: action.payload,
		isChanged: true,
	}),
	[addCoFComponent.toString()]: (state, action) => ({
		...state,
		categories: state.categories.map(category =>
			category.name === action.payload.categoryName
				? {
						...category,
						components: [
							...category.components,
							action.payload.component,
						],
				  }
				: category,
		),
		isChanged: true,
	}),
	[setCoFComponent.toString()]: (state, action) => ({
		...state,
		categories: state.categories.map(category =>
			category.name === action.payload.categoryName
				? {
						...category,
						components: category.components.map(component =>
							component.name === action.payload.componentName
								? action.payload.component
								: component,
						),
				  }
				: category,
		),
		isChanged: true,
	}),
	[setCoFComponents.toString()]: (state, action) => ({
		...state,
		categories: state.categories.map(category =>
			category.name === action.payload.categoryName
				? {
						...category,
						components: action.payload.components,
				  }
				: category,
		),
		isChanged: true,
	}),
	[saveCoFResolved.toString()]: state => ({
		...state,
		isChanged: false,
	}),
	[deleteCoFCategory.toString()]: (state, action) => {
		if (!action.payload.forLoF) {
			return {
				...state,
				categories: state.categories.filter(
					category => category.name !== action.payload.categoryName,
				),
				isChanged: true,
			};
		} else {
			return { ...state };
		}
	},
	[setCoFIsChanged.toString()]: (state, action) => ({
		...state,
		isChanged: action.payload,
	}),
};

export const cofReducer = createReducer(initState, reducer);
